<template>
    <header class="bg-white py-4" style="box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);">
        <div class="flex flex-col max-w-screen-xl mx-auto px-4 lg:px-8">
            <div class="flex justify-between">
                <div class="flex gap-x-5">
                    <a href="https://www.thetruckersreport.com/" title="TruckersReport.com">
                        <img src="https://www.thetruckersreport.com/wordpress/wp-content/themes/truckersreport/images/tr-logo.svg" alt="TruckersReport.com logo" style="height: 42px">
                    </a>
                    <img src="/proposal-presentation-files/img/hammer-logo-small.png" alt="Hammer app logo" style="height: 42px">
                </div>

                <div class="flex items-center">
                    <button 
                        type="button" 
                        class="inline-flex items-center justify-center rounded-md p-2 text-navy hover:bg-navy hover:text-white" 
                        @click="isOpen = !isOpen"
                    >
                    <svg v-if="! isOpen" class="block h-6 w-6" id="icon-open-menu" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
                    </svg>
                    <svg v-if="isOpen" class="block h-6 w-6" id="icon-close-menu" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                    </button>
                </div>
            </div>

            <div v-if="isOpen" class="flex-col gap-y-1 mt-4">
                <a v-for="(sectionName, sectionKey) in menu"
                    :key="sectionKey"
                    :href="'#' + sectionKey" 
                    class="text-navy hover:bg-navy hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                >
                    {{ sectionName }}
                </a>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    props: [
        'proposal_document',
    ],
    data() {
        return {
            isOpen: false,
        }
    },
    computed: {
        menu() {
            const menu = {
                our_goals: "Our Goals",
                job_board: "Unlimited Job Board Posts",
                hiring_area: "Job Posts in Every City of Your Hiring Area",
                hammer_and_job_adviser: "Hammer GPS & Job Adviser",
                mc_leads: "Multi-Carrier Leads",
                video_advertising: "Video Advertising",
                brand_and_reputation: "Brand & Reputation",
                new_hire_guarantee: "TruckersReport New Hire Guarantee",
                pricing_options: "Pricing",
            };

            let sections = this.proposal_document.sections;
            return _.pickBy(menu, function(section, key) {
                return sections[key] && sections[key].is_active === true;
            })
        }
    },
}
</script>